"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const MenuIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== 'auto') {
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
        size.width = width;
    }
    if (height && height !== 'auto') {
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
        size.height = height;
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ id: "Capa_1", "data-name": "Capa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 198 148.53" }, size, { style: Object.assign({}, insetPosition), fill: fill }),
            react_1.default.createElement("defs", null),
            react_1.default.createElement("path", { d: "M9.48,42.24a8.25,8.25,0,1,1,0-16.5h181a8.25,8.25,0,1,1,0,16.5Z", transform: "translate(-1 -25.74)" }),
            react_1.default.createElement("path", { d: "M190.52,91.74a8.26,8.26,0,1,1,0,16.51H9.48a8.26,8.26,0,1,1,0-16.51Z", transform: "translate(-1 -25.74)" }),
            react_1.default.createElement("path", { d: "M190.52,157.75a8.26,8.26,0,1,1,0,16.51H9.48a8.26,8.26,0,1,1,0-16.51Z", transform: "translate(-1 -25.74)" }))));
};
exports.default = MenuIconM;
//# sourceMappingURL=index.js.map